import { useSelector } from 'react-redux';
import Commons from '../Services/Common/Common';
import Global from '../Services/Common/Global';

export default function useActionLog() {
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const user = userInfo || {};

  const SaveActionLog = async (
    rows = [],
    { menuId, coCd, userId, logResult = 'SUCCESS', errorMsg = '' }
  ) => {
    const coCdSafe = coCd || (user.authCd === 'ADMIN' ? '' : user.coCd);
    const userIdSafe = userId || user.userid;
    const menuIdSafe = menuId || '';

    const isFlagTrue = (v) =>
      v === 'Y' || v === 'y' || v === true || v === 'true';

    for (const row of rows) {
      let actionType = '';

      if (isFlagTrue(row.newYn)) actionType = 'INSERT';
      else if (isFlagTrue(row.deleteYn)) actionType = 'DELETE';
      else if (isFlagTrue(row.editYn)) actionType = 'UPDATE';
      else actionType = 'UPDATE';

      try {
        const payload = [
          {
            MenuId: Commons.EncryptAES(menuIdSafe),
            CoCd: Commons.EncryptAES(coCdSafe),
            UserId: userIdSafe,
            ActionResult: Commons.EncryptAES(logResult), // SUCCESS/ERROR 또는 ''
            ActionType: Commons.EncryptAES(actionType), // INSERT/UPDATE/DELETE 또는 ''
            ErrorMsg: Commons.EncryptAES(errorMsg), // 에러 메시지 또는 ''
          },
        ];

        await Commons.Axios(
          'post',
          `${Global.base.useUrl}${Global.urls.Utility.saveActionLog}`,
          payload
        );
      } catch (e) {
        console.error('❌ SaveActionLog Exception:', e);
      }
    }
  };

  return { SaveActionLog };
}
